import { computed, makeObservable } from "mobx";
export class Retriever {
    constructor(options) {
        this.handleReconnect = () => {
            this.betsRetriever.handleReconnect();
            this.cashOutRetriever.handleReconnect();
        };
        this.activate = () => {
            if (!this.isLoggedInOnLoad) {
                return;
            }
            this.myBetsConnection.subscribe({
                name: "BetsQuery",
                params: undefined,
                onData: this.handleData.bind(this),
                onError: this.onError.bind(this),
            }, (myBetsSubscription) => {
                this.betsRetriever.activate(myBetsSubscription);
                this.cashOutRetriever.activate(myBetsSubscription);
            }, this.handleReconnect.bind(this), this.setStatusOnClose.bind(this));
            this.bonusesRetriever.activate();
        };
        this.deactivate = () => {
            var _a, _b;
            this.cashOutRetriever.deactivate();
            this.betsRetriever.deactivate();
            this.bonusesRetriever.deactivate();
            (_b = (_a = this.myBetsConnection).deactivate) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.loadMoreBets = (request) => {
            this.betsRetriever.loadMoreBets(request, "nextBetsPage");
        };
        this.clearBets = () => {
            this.betsRetriever.clearBets();
        };
        this.skip = () => this.betsRetriever.skip;
        this.lastRequest = () => this.betsRetriever.lastRequest;
        this.updateCashOutInformationStatus = (betId, newStatus) => {
            this.cashOutRetriever.updateCashOutInformationStatus(betId, newStatus);
        };
        this.updateCashOutOperationStatus = (betId, newStatus) => {
            this.cashOutRetriever.updateCashOutOperationStatus(betId, newStatus);
        };
        this.requestCashOut = (request) => {
            this.cashOutRetriever.requestCashOut(request);
        };
        this.acceptCashOutNewOffer = (request) => {
            this.cashOutRetriever.acceptCashOutNewOffer(request);
        };
        this.deleteCashOutOperation = (betId) => {
            this.cashOutRetriever.deleteCashOutOperation(betId);
        };
        this.deleteCashOutInformation = (betId) => {
            this.cashOutRetriever.deleteCashOutInformation(betId);
        };
        this.getBonusDetailsById = (request) => this.bonusesRetriever.getBonusDetailsById(request);
        this.betsRetriever = options.betsRetriever;
        this.cashOutRetriever = options.cashOutRetriever;
        this.bonusesRetriever = options.bonusesRetriever;
        this.myBetsConnection = options.connection;
        this.isLoggedInOnLoad = options.isLoggedInOnLoad;
        makeObservable(this, {
            bets: computed.struct,
            events: computed.struct,
            status: computed,
            cashOutInformations: computed,
            cashOutOperations: computed,
            bonusDetails: computed
        });
    }
    get bets() {
        return this.betsRetriever.bets;
    }
    get events() {
        return this.betsRetriever.events;
    }
    get status() {
        return this.betsRetriever.status;
    }
    get cashOutInformations() {
        return this.cashOutRetriever.cashOutInformations;
    }
    get cashOutOperations() {
        return this.cashOutRetriever.cashOutOperations;
    }
    get bonusDetails() {
        return this.bonusesRetriever.bonusDetails;
    }
    handleData(data) {
        this.betsRetriever.onData(data);
        this.cashOutRetriever.onData(data);
    }
    onError(error) {
        this.betsRetriever.onError(error);
    }
    setStatusOnClose() {
        this.betsRetriever.setStatusOnClose();
    }
}
//# sourceMappingURL=Retriever.js.map